import { useMutation } from "@tanstack/react-query";
import axiosManagerRegister from "../../../services/axiosManagerRegister";
import { useToast } from "../../../context/toast";
import { useTranslate } from "../../../hooks/useTranslate";

export const useUpdateChild = () => {
    const { t } = useTranslate();
    const toast = useToast();

    const {
        mutateAsync: updateChild, isPending: isUpdatingChild,
    } = useMutation({
        mutationFn: ({ regId, leadId, requestData }) => axiosManagerRegister.put$(`/api/api/registration/${regId}/child`, { ...requestData, onlineRegistrationId: regId, leadId }).then((response) => response?.data),
        onError: () => {
            toast.error(t("common.errorMessage"));
        },
    });

    return {
        updateChild, isUpdatingChild,
    };
};
